import { graphql } from 'react-relay';

export const ScheduleItemsQuery = graphql`
    query ScheduleItemsQuery(
        $first: Int
        $page: Int
        $after: String
        $filter_field: [String]
        $filter_flexible: String
        $order_by: [String]
    ) {
        ...ScheduleItemListFragment
            @arguments(
                after: $after
                first: $first
                page: $page
                filter_field: $filter_field
                order_by: $order_by
                filter_flexible: $filter_flexible
            )
    }
`;
